/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2021-01-15 10:49:13
 * @LastEditors: zhangxu
 * @LastEditTime: 2025-11-11 12:12:25
 */
import At from '@/str/CodeMap'
import { teacherList } from '@/api/course-manage'
import { getDictLists } from '@/api/dic'

export function globalDictLists() {
  teacherList({
    data: {},
    success: res => {
      if (res.code === 1) {
        let newArr = []
        res.data.forEach(item => {
          let obj = { label: item.teacherName, value: item.teacherId }
          newArr.push(obj)
        })
        At.teacherList = newArr
      }
    }
  })
  let typeNames =
    'VIP_STATUS,GRADE,COURSE_TYPE,SURPLUS_PLAN,PRICE_TYPE,ORDER_STATUS,REFUND_STATUS,EMPLOYEE_STATUS,ORDER_STATUS,TJW_ORDER_STATUS,ORDER_SERVICE_STATUS,CHANNEL_ORDER_SERVICE_STATUS,ORDER_STAGE,PAYMENT_TYPE,ERP_PRICE_TYPE,MEMBER_TYPE,SERVICE_TYPE,SUBJECT,TEACHING_MATERIAL,GRADE_PERIOD,REPORT_REASSON,BULLET_SCREEN_SILENCE,SUPERMEMBERPRODUCT,CITY_LEVEL,GOODS_CLASSIFY,CLASSIFICATION,ARTICLE_CATEGORY,DIFFICULTY_LAYERED,QUESTION_TYPE, JYW_DEGREE,JYW_QUESTION_LABEL,QUESTION_SOURCE_LABEL,USER_AUTH_LEVEL,EDUCATION,OCCUPATION_CODE,EXPECT_ROI_PERIOD,CAPITAL_RANGE,CUSTOMER_SOURCE,MESSAGE_TYPE,PROMO_CHANNEL,INIT_SCORE_RATE'

  getDictLists({
    typeNames: typeNames
  }).then(res => {
    for (let typeName in res) {
      switch (typeName) {
        case 'GRADE':
          // 年级
          var newArr = []
          res[typeName].forEach(item => {
            let obj = { label: item.dictName, value: item.dictValue }
            newArr.push(obj)
          })
          At.grade = newArr
          break
        case 'COURSE_TYPE':
          // 课程类型
          var newArr = []
          res[typeName].forEach(item => {
            let obj = { label: item.dictName, value: item.dictValue }
            newArr.push(obj)
          })
          At.courseType = newArr
          break
        case 'REFUND_STATUS':
          // 退费状态
          var newArr = []
          res[typeName].forEach(item => {
            let obj = { label: item.dictName, value: item.dictValue }
            newArr.push(obj)
          })
          At.refundStatus = newArr
          break
        // 套餐类型
        // case 'PRICE_TYPE':
        // var newArr = []
        // res[typeName].forEach(item => {
        //   let obj = { label: item.dictName, value: item.dictValue }
        //   newArr.push(obj)
        // })
        //At.mealTypeList = newArr
        //break
        // 员工状态
        case 'EMPLOYEE_STATUS':
          At.staffStatus = [{ dictName: '全部', dictValue: '' }, ...res[typeName]]
          break
        case 'ORDER_STATUS':
          // 订单状态
          At.orderStatus = res[typeName]
          break
        case 'TJW_ORDER_STATUS':
          // 订单状态
          At.orderStatusTjw = res[typeName]
          break
        case 'ORDER_SERVICE_STATUS':
          At.orderServiceStatus = res[typeName]
          break
        case 'CHANNEL_ORDER_SERVICE_STATUS':
          At.channelOrderServiceStatus = res[typeName]
          break
        case 'ORDER_STAGE':
          //订单类型
          At.orderType = res[typeName]
          break
        case 'PAYMENT_TYPE':
          //支付方式
          At.paymentTypeList = res[typeName]
          break
        case 'ERP_PRICE_TYPE':
          var newArr = []
          res[typeName].forEach(item => {
            let obj = { label: item.dictName, value: item.dictValue }
            newArr.push(obj)
          })
          At.mealTypeList = newArr
          At.videoPriceType = res[typeName]
          break
        case 'MEMBER_TYPE':
          At.memberTypeList = res[typeName]
          break
        case 'SERVICE_TYPE':
          At.serviceTypeList = res[typeName]
          break
        case 'SUBJECT':
          // var newArr = []
          // res[typeName].forEach(item => {
          //   let obj = { label: item.dictName, value: item.dictValue }
          //   newArr.push(obj)
          // })
          At.subjects = res[typeName]
          At.subjectModels = res[typeName]
          break
        case 'TEACHING_MATERIAL':
          At.teachingMaterial = res[typeName]
          break
        case 'GRADE_PERIOD':
          At.gradePeriodList = res[typeName]
          break
        case 'INIT_SCORE_RATE':
          At.initialScoreRateList = [{ dictName: '初始得分率', dictValue: 'initial' }, ...res[typeName]]
          break
        case 'VIP_STATUS':
          // 会员状态
          At.vipStatusArr = res[typeName]
          break
        case 'REPORT_REASSON':
          // 举报理由字典值
          At.handleReasons = res[typeName]
          break
        // case 'BULLET_SCREEN_SILENCE':
        //   // 弹幕禁言处罚字典值
        //   At.deductSilences = res[typeName]
        //   break
        case 'SUPERMEMBERPRODUCT':
          At.superMemberProductList = res[typeName]
          break
        case 'CITY_LEVEL': //城市级别
          At.cityLevel = res[typeName]
          break
        case 'GOODS_CLASSIFY': //商品分类
          At.goodsClassify = res[typeName]
          break
        case 'CLASSIFICATION': //代理类型
          At.classificationList = res[typeName]
          break
        case 'ARTICLE_CATEGORY': //文章类型
          At.articleCategory = res[typeName]
          break
        // 难度
        case 'DIFFICULTY_LAYERED':
          At.difficultyLayeredList = res[typeName]
          newArr = []
          res[typeName].forEach(item => {
            let obj = { label: item.dictName, value: item.dictValue }
            newArr.push(obj)
          })
          At.difficulty = newArr
          break
        //试题难度
        case 'QUESTION_TYPE':
          At.qTypeList = res[typeName]
          break
        //试题题型
        case 'JYW_DEGREE':
          At.diffList = res[typeName]
          break
        //试题题类
        case 'JYW_QUESTION_LABEL':
          At.quesLabelList = res[typeName]
          break
        //试题来源
        case 'QUESTION_SOURCE_LABEL':
          At.quesSourceList = res[typeName]
          break
        //伴学师级别
        case 'USER_AUTH_LEVEL':
          At.userAuthLevelList = res[typeName]
          break
        case 'EDUCATION':
          At.education = res[typeName]
          break
        case 'OCCUPATION_CODE':
          At.occupation_code = res[typeName]
          break
        case 'EXPECT_ROI_PERIOD':
          At.expect_roi_period = res[typeName]
          break
        case 'CAPITAL_RANGE':
          At.capital_range = res[typeName]
          break
        case 'CUSTOMER_SOURCE':
          At.customerSource = res[typeName]
          break
        // 推广渠道
        case 'PROMO_CHANNEL':
          At.customerSource = res[typeName]
          break
        case 'MESSAGE_TYPE':
          At.messageTypesAll = res[typeName]
          break
      }
    }
  })
}
